import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import Error from "./Error";
import styles from "./styles";

const enhance = compose(
  withRouter,
  withStyles(styles)
);

export default enhance(Error);
